import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1231 23H7.37685C5.51143 23 4 21.5018 4 19.6527V4.34732C4 2.49822 5.51143 1 7.37685 1H15.8423L20.5 5.63778V19.6527C20.5 21.5018 18.9886 23 17.1231 23Z",
			fill: "#809BBE"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.5 5.63778H16.7994C16.2755 5.63778 15.8493 5.21763 15.8493 4.69822L15.8423 1",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3983 12.7641L10.3344 9.95232C10.2366 9.88537 10.1016 9.95232 10.1016 10.0724V15.6959C10.1016 15.8136 10.2366 15.8829 10.3344 15.8159L14.3983 13.0042C14.4822 12.9464 14.4822 12.8218 14.3983 12.7641Z",
			fill: "#E6EAF1"
		})
	]
});
export default SvgVideo;
